module.exports = __webpack_public_path__ + "img/logo25px.0a0c732c.svg";